import { useEffect } from 'react';
import { useFeature } from '@24i/nxg-sdk-smartott-shared/src/context/AppSettingsData';
import { log } from '@24i/nxg-core-utils/src/logger';
import { OneTrust } from '../../utils/oneTrust';

export const useOneTrust = () => {
    const config = useFeature('oneTrust');

    useEffect(() => {
        OneTrust?.init(config).catch((error: string) => {
            log(`An error occurred during dynamic import OneTrust web SDK ${error}`);
        });
    }, [config]);
};
